var React = require('react');

function IconShieldBigInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M56.5204 64.4858V1H1.22632V64.4858H56.5204Z","stroke":"#268BAB","key":0}),React.createElement("path",{"d":"M97.0293 55.7037L97.4789 44.6891H42.1848V130.702C73.9844 119.139 95.6494 89.5123 97.0293 55.7037Z","stroke":"#268BAB","key":1}),React.createElement("path",{"d":"M72.9038 25.5751V81.5518H17.6097","stroke":"#268BAB","key":2})]);
}

IconShieldBigInline.defaultProps = {"width":"98","height":"132","viewBox":"0 0 98 132","fill":"none"};

module.exports = IconShieldBigInline;

IconShieldBigInline.default = IconShieldBigInline;
